import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./ForgotPassword'));

function LoadableForgotPassword() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableForgotPassword;
